import { CHANGE_LOCATIONS, FETCH_STEPS, FETCH_SYSTEM, FETCH_TRANSLATIONS, UPDATE_CONFIG } from './actions';
import { System } from './types';
import { setNewWidgetCustomStyles } from '../utils/utils';

const initialState: System = {
  company: '',
  locations: [],
  defaultLanguage: '',
  formConfig: null,
  translations: {},
  configTranslations: {},
  currency: null,
  pricing: null,
  widgetConfig: null,
  unitsConfig: null,
  systemLoaded: false,
};

export function systemReducer(state = initialState, action: any): System {
  switch (action.type) {
    case FETCH_SYSTEM: {
      const data = action.payload as System;
      const cfg = data?.widgetConfig;

      if (cfg) {
        setNewWidgetCustomStyles(cfg);
      }

      return { ...data, systemLoaded: true, configTranslations: data.translations };
    }

    case FETCH_TRANSLATIONS: {
      const data = action.payload as System;

      return { ...state, translations: data.translations };
    }

    case FETCH_STEPS: {
      return { ...state, locations: action.payload.locations };
    }

    case UPDATE_CONFIG: {
      setNewWidgetCustomStyles(action.payload);

      return { ...state, widgetConfig: action.payload };
    }

    case CHANGE_LOCATIONS: {
      return { ...state, locations: action.payload };
    }

    default:
      return state;
  }
}
